module.exports = __webpack_public_path__ + "img/el.1eab628f.svg";